import React, {
    Component
} from 'react';

import PropTypes from 'prop-types';
import TagManager from './../../../js/utils/tagManager';

class Analytics extends Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        let target;
        target = this.props.proxy;
        if(this.props.proxy.querySelector('a')){
            target = this.props.proxy.querySelector('a');
        }
        target.onclick = this.trackEvent.bind(this);
    }

    trackEvent(event) {
        TagManager.pushEvent(this.props.event,this.props.category,this.props.action,this.props.label);
    }


    render() {
        return <div></div>
    }
}

Analytics.propTypes = {
    event: PropTypes.string,
    category: PropTypes.string,
    action: PropTypes.string,
    label: PropTypes.string
}

export default Analytics


// WEBPACK FOOTER //
// ./vendor/bbs/crt/src/resources/views/components/tracking/Analytics.js